module.exports = __webpack_public_path__ + "static/media/type-1.513dc8b3.svg";